import { render, staticRenderFns } from "./RiasecCongratulation.vue?vue&type=template&id=6ade2646&scoped=true"
import script from "./RiasecCongratulation.vue?vue&type=script&lang=js"
export * from "./RiasecCongratulation.vue?vue&type=script&lang=js"
import style0 from "./RiasecCongratulation.vue?vue&type=style&index=0&id=6ade2646&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ade2646",
  null
  
)

export default component.exports